const generateSliderStyles = require('./generate-slider-styles.js')

const rooster = {
  postPill: {
    zIndex: '100',
    position: 'absolute',
    backgroundColor: '#ebebeb',
    height: '40%',
    width: '130px',
    padding: '5px',
    left: 0,
    borderRadius: '500px',
    bottom: '50%',
    transform: 'translate(0, 50%)',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  apptTypePill: {
    zIndex: '100',
    position: 'absolute',
    backgroundColor: '#ebebeb',
    height: '40%',
    width: '150px',
    padding: '5px',
    left: 0,
    borderRadius: '500px',
    top: '-32px',
    transform: 'translate(0, 50%)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  handleContainer: {
    position: 'absolute',
    height: '100%',
    left: '157px',
    width: '860px',
  },
}

// TODO: actually go back to this if we ever activate customPost for tops
const tops = {
  postPill: {
    zIndex: '100',
    position: 'absolute',
    backgroundColor: '#555555',
    height: '40%',
    width: '130px',
    padding: '5px',
    left: 0,
    borderRadius: '500px',
    bottom: '50%',
    transform: 'translate(0, 50%)',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  apptTypePill: {
    zIndex: '100',
    position: 'absolute',
    backgroundColor: '#555555',
    height: '40%',
    width: '150px',
    padding: '5px',
    left: 0,
    borderRadius: '500px',
    top: '-32px',
    transform: 'translate(0, 50%)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  handleContainer: {
    position: 'absolute',
    height: '100%',
    left: '157px',
    width: '860px',
  },
}

const pillWidth = '170px'

module.exports = process.env.REACT_APP_IS_TOPS
  ? generateSliderStyles(rooster, {
      timeLabelColor: '#555555',
      pillWidth,
      isTops: true,
    })
  : generateSliderStyles(rooster, {
      timeLabelColor: '#8f8f8f',
      pillWidth,
    })



// WEBPACK FOOTER //
// ./src/components/Settings/styles/Sliders/CustomPost.js